import type { SourceAssetView } from "./api-client.ts";

export function appendUniqueSourceAssets(
  current: readonly SourceAssetView[],
  page: readonly SourceAssetView[],
): SourceAssetView[] {
  const sourceIds = new Set(current.map(({ sourceGifId }) => sourceGifId));
  const merged = [...current];
  for (const source of page) {
    if (sourceIds.has(source.sourceGifId)) continue;
    sourceIds.add(source.sourceGifId);
    merged.push(source);
  }
  return merged;
}
